
module.exports = {
    BEEN_TO_JOBS: 'been_to_jobs',
    BEEN_TO_CAREER_MATCHES: 'been_to_career_matches',
    NEW_PERSONALITY: 'new_personality',
    SECONDARY_EMAIL: 'secondary-email',
    TERMS_AND_CONDITIONS: 'terms-and-conditions',
    MILITARY_CROSSWALK: 'military_crosswalk',
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/notifications.js
// module id = 130
// module chunks = 58